export type ReviewMarkerCategory = 'sold' | 'accepted' | 'rejected' | 'digital' | 'other';

export const REVIEW_MARKER_CATEGORY_COLORS: Record<ReviewMarkerCategory, string> = {
  sold: 'hsl(240,5%,65%)',
  accepted: 'hsl(142,71%,40%)',
  rejected: 'hsl(0,84%,55%)',
  digital: 'hsl(217,91%,55%)',
  other: 'hsl(262,60%,55%)',
};
